import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getTaxListSaga = createAction(
  "GET_TAX",
  ({ payload, params }: SagaActionParams<Type.TaxDto[]>) => ({
    payload,
    url: "/api/admin/adminvat" + (params ? params : ""),
  })
);
export const getTaxDetailsSaga = createAction(
  "GET_TAX_DETAILS",
  ({ payload, id }: SagaActionParams<Type.TaxDetailDto>) => ({
    payload,
    url: "/api/admin/adminvat/" + id,
  })
);
export const createTaxSaga = createAction(
  "CREATE_TAX",
  ({ payload, body }: SagaActionParams<Type.TaxDto>) => ({
    payload,
    url: "/api/admin/adminvat",
    body,
  })
);
export const updateTaxSaga = createAction(
  "UPDATE_TAX",
  ({ payload, id, body }: SagaActionParams<Type.TaxDto>) => ({
    payload,
    url: "/api/admin/adminvat/" + id,
    body,
  })
);
export const deleteTaxSaga = createAction(
  "DELETE_TAX",
  ({ payload, id }: SagaActionParams<Type.TaxDto>) => ({
    payload,
    url: "/api/admin/adminvat/" + id,
  })
);

const taxesSaga = [
  takeLatest<any>(
    getTaxListSaga.toString(),
    (payload: SagaGenericParams<Type.TaxDto[]>) =>
      getSaga<Type.TaxDto[]>(payload)
  ),
  takeLatest<any>(
    getTaxDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.TaxDetailDto>) =>
      getSaga<Type.TaxDetailDto>(payload)
  ),
  takeLatest<any>(
    createTaxSaga.toString(),
    (payload: SagaGenericParams<Type.TaxDto>) => postSaga<Type.TaxDto>(payload)
  ),
  takeLatest<any>(
    updateTaxSaga.toString(),
    (payload: SagaGenericParams<Type.TaxDto>) => putSaga<Type.TaxDto>(payload)
  ),
  takeLatest<any>(deleteTaxSaga.toString(), (payload: SagaGenericParams<any>) =>
    deleteSaga<Type.TaxDto>(payload)
  ),
];

export default taxesSaga;
